import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';
import { IntentionsDrawerControlMenuItem, IntentionsDrawerControls } from './IntentionsDrawerControls';
import type { IntentionsDrawerControlMenuItemProps, IntentionsDrawerControlsProps } from './IntentionsDrawerControls';
import { useIntentionsDrawerControls } from './useIntentionsDrawerControls';

export function IntentionsDrawerControlsWrapper(props: Pick<IntentionsDrawerControlsProps, 'className'>) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useIntentionsDrawerControls();

  return shouldShowButton ? (
    <IntentionsDrawerControls
      {...props}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
      tooltipText={helperText}
    />
  ) : null;
}

export function IntentionsDrawerControlMenuItemWrapper(props: Pick<IntentionsDrawerControlMenuItemProps, 'className'>) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useIntentionsDrawerControls();

  return shouldShowButton ? (
    <IntentionsDrawerControlMenuItem
      className={props.className}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
      helperText={helperText}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
    />
  ) : null;
}
